import { FC } from "react";
import { Icon } from "../../../models/icons/Icon";
import { cn } from "@/lib/utils";
import { Button } from "@capacit-com/lara-law-shared-ui";

type Props = {
  icon: Icon;
  active: boolean;
  activeClassName: string;
  onClick: () => void;
  testId?: string;
  className?: string;
};

const MessageBubbleActionBarItem: FC<Props> = ({
  icon: Icon,
  active,
  activeClassName,
  onClick,
  testId,
  className,
}) => {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className={cn("px-2 transition-all duration-300", className)}
      data-testid={testId}
      size="sm"
    >
      <Icon className={cn(active && activeClassName, className)} />
    </Button>
  );
};

export default MessageBubbleActionBarItem;
